import { Col, Row } from 'antd';
import { NewOrganisationModalEnum } from 'enums/organisationMapEnums';
import React from 'react';
import styles from './newOrganisationModal.module.scss';
import { Organization } from 'models/CompanySetup/organization.model';
import clsx from 'clsx';
import { MetaData } from 'models/MetaData/metaData.model';
import { OrganizationDetails } from 'models/OrganizationDetails/organizationDetails.model';

const {
  SECTOR_FIELD_NAME,
  COMPANY_TYPE_FIELD_NAME,
  ORGANIZATION_DETAILS,
  REPORTING_DETAILS,
} = NewOrganisationModalEnum;

export interface NewOrganisationModalProps {
  isOpen: boolean;
  onClose: () => void;
  isMainParent?: boolean;
  updateOrganisation?: (props: {
    organisationName?: string;
    organisation?: Organization;
  }) => void;
  organisationList?: MetaData[];
  data?: OrganizationDetails;
  handleSubmit?: (formValues: OrganizationDetails) => Promise<boolean>;
  loading?: boolean;
}

export const getAppendedName = (
  name: string,
  data?: OrganizationDetails
): string => {
  return `${data?.organization?.id ? 'organization.' : ''}${name}`;
};

export const handleCompanyTypeChange =
  (
    setFieldValue: (
      field: string,
      value?: number | null,
      shouldValidate?: boolean
    ) => void,
    fetchSector: (companyTypeId: number) => Promise<void>,
    data?: OrganizationDetails
  ) =>
  async (value: number) => {
    const companyTypeField = getAppendedName(COMPANY_TYPE_FIELD_NAME, data);
    const sectorField = getAppendedName(SECTOR_FIELD_NAME, data);
    setFieldValue(companyTypeField, value ?? null);
    setFieldValue(sectorField, null);
    value && (await fetchSector(value));
  };

export const getMainParentTabData = (
  activeTab: NewOrganisationModalEnum,
  isMainParent?: boolean
) => {
  const parentFormTabs = [ORGANIZATION_DETAILS, REPORTING_DETAILS];
  return isMainParent ? (
    <Col span={24} className={styles.parentFormTabs}>
      <Row className={styles.rowContainer}>
        {parentFormTabs.map(item => (
          <Col span={12} className={styles.tabItemContainer} key={item}>
            <div
              className={clsx(styles.tab, {
                [styles.active]: activeTab === item,
              })}>
              {item}
            </div>
          </Col>
        ))}
      </Row>
    </Col>
  ) : null;
};
